class HeaderSearchDesktop extends HTMLElement {
    constructor() {
      super();
      this.render();
      this.setupEventListeners();
      this.searchQuery = "";
    }
  
    render() {
      this.innerHTML = `
        <div class="header-search-wrapper">
          <div class="input-header-wrapper">
            <input class="search-input" type="text" />
          </div>
          <div class="input-header-text-img-wrapper">
            <img class="right-header-menu-img icon-white" src="${this.getAttribute('icon-url-white')}" />
            <img class="right-header-menu-img icon-black" src="${this.getAttribute('icon-url-black')}" />
            <div class="right-header-menu-text">
              SEARCH
            </div>
          </div>
          <div class="input-results-wrapper">

          </div>
        </div>
      `;
    }
  
    setupEventListeners() {

        // --- Reinicializar el input desde cero al montar o al volver atrás ---
        const hardResetInput = () => {
        const oldInput = this.querySelector('.search-input');
        if (oldInput) {
            const parent = oldInput.parentElement;
            const newInput = document.createElement('input');
            newInput.type = 'text';
            newInput.className = 'search-input';
            newInput.setAttribute('autocomplete', 'off');
            newInput.setAttribute('autocorrect', 'off');
            newInput.setAttribute('autocapitalize', 'off');
            newInput.setAttribute('spellcheck', 'false');
            newInput.placeholder = ''; // sin placeholder visible
            newInput.name = 'q_' + Math.random().toString(36).slice(2); // nombre aleatorio
            parent.replaceChild(newInput, oldInput);
        }
        };

        // Llamamos al cargar el componente
        hardResetInput();

        // Y si el navegador restaura la página desde el caché (BFCache)
        window.addEventListener('pageshow', (e) => {
        if (e.persisted) hardResetInput();
        });
      const input        = this.querySelector('.search-input');

      input.addEventListener('focus', () => {
          this.classList.add("input-is-focused");
      });
      
      input.addEventListener('focusout', () => {
          if (!input.value.length) {
              this.classList.remove("input-is-focused");
          }
      });
      
      input.addEventListener('input', () => {
          if (input.value.length) {
              this.classList.add("input-has-content");
          } else {
              this.classList.remove("input-has-content");
          }
          this.searchQuery = input.value;
          this.searchFor(this.searchQuery);
      });
      
      input.addEventListener('keydown', async (event) => {
          if (event.key === 'Enter') {
              event.preventDefault();
              await this.handleEnterKey();
          }
      });
    }


    async searchFor(searchParam) {

        this.displayDefaultResults();

        try {
            const response = await fetch(
                `/search?q=${encodeURIComponent(searchParam)}&type=product`,
                {
                    headers: {
                        'Accept': 'application/json'
                    }
                }
            );
            
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            if (this.searchQuery !== searchParam) {
                return;
            }
            
            // Extraer productos del HTML
            const products = this.parseProductsFromHTML(doc);
            this.displaySearchResults(products);
        } catch (error) {
            console.error('Error searching products:', error);
            this.displaySearchResults([]);
        }
    }

    parseProductsFromHTML(doc) {
        const productElements = doc.querySelectorAll('.card-wrapper, .product-card, [data-product-id]');
        const products = [];
        
        productElements.forEach(el => {
            const link = el.querySelector('a[href*="/products/"]');
            const title = el.querySelector('.card__heading, .product-title, h3, h2');
            
            if (link && title) {
                products.push({
                    url: link.href,
                    title: title.textContent.trim()
                });
            }
        });
        
        return products;
    }


    displayDefaultResults() {
        this.displayResults(``);
    }

    displaySearchResults(products) {
        this.lastSearchResults = products;
        let resultsHTML = `<span>NO RESULTS FOUND.</span>`

        if (products.length) {
            resultsHTML = products.slice(0, 5).map(product => `
                <a href="${product.url}">
                    ${product.title}
                </a>
            `).join('');
        }
        this.displayResults(resultsHTML)
    }
    
    displayResults(resultsContent) {
        const inputResults = this.querySelector('.input-results-wrapper');

        inputResults.innerHTML = `
            <div class="results">
                ${resultsContent}
            </div>
        `;
    }

    async handleEnterKey() {
        if (!this.lastSearchResults || this.lastSearchResults.length !== 1) {
            // If there's not exactly one result, perform default search
            if (this.searchQuery) {
                window.location.href = `/search?q=${encodeURIComponent(this.searchQuery)}`;
            }
            return;
        }

        const product = this.lastSearchResults[0];
        const productHandle = this.getProductHandleFromUrl(product.url);
        
        if (productHandle) {
            const dropCollection = await this.getProductDropCollection(productHandle);
            if (dropCollection) {
                window.location.href = `/collections/${dropCollection}`;
                return;
            }
        }
        
        // Fallback to product page
        window.location.href = product.url;
    }

    getProductHandleFromUrl(url) {
        const match = url.match(/\/products\/([^?\/]+)/);
        return match ? match[1] : null;
    }

    async getProductDropCollection(productHandle) {
        try {
            const response = await fetch(`/products/${productHandle}.js`);
            const productData = await response.json();
            
            // Find a collection that starts with "drop-"
            if (productData.collections) {
                for (let collection of productData.collections) {
                    if (collection.handle && collection.handle.startsWith('drop-')) {
                        return collection.handle;
                    }
                }
            }
            return null;
        } catch (error) {
            console.error('Error fetching product collections:', error);
            return null;
        }
    }

}
  
customElements.define('header-search-desktop', HeaderSearchDesktop);